module.exports = __webpack_public_path__ + "static/media/confusedActive.65bf1358.svg";